class CartRecommendations {
  constructor() {
    this.track = null;
    this.slides = [];
    this.index = 0;

    // Initial load
    this.load();
    

    // Reload whenever Dawn updates the cart
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.load();
    });

    // Event delegation
    document.addEventListener("click", (e) => {
      const next = e.target.closest(".cart-slider-next");
      const prev = e.target.closest(".cart-slider-prev");
      const add = e.target.closest(".recommendation-add");

      if (next) {
        this.next();
        return;
      }

      if (prev) {
        this.prev();
        return;
      }

      if (add) {
        this.addProduct(add);
      }
    });
  }

  async load() {
    const cart = await fetch("/cart.js").then((r) => r.json());

    if (!cart.items.length) return;

    const lastProduct = cart.items[cart.items.length - 1];

    const html = await fetch(
      `/recommendations/products?section_id=cart-recommendations&product_id=${lastProduct.product_id}&limit=6`
    ).then((r) => r.text());

    const doc = new DOMParser().parseFromString(html, "text/html");

    const recommendation = doc.querySelector(".cart-recommendations");

    if (!recommendation) return;

    document.querySelector("#DrawerRecommendations").innerHTML =
      recommendation.outerHTML;

    this.track = document.querySelector(".cart-slider-track");
this.slides = document.querySelectorAll(".cart-slide");
this.index = 0;

// Force browser reflow
this.track.offsetHeight;

// Update after the browser has painted
requestAnimationFrame(() => {
  this.update();
});
  }

  next() {
    if (!this.track) return;

    if (this.index >= this.slides.length - 1) return;

    this.index++;

    this.update();
  }

  prev() {
    if (!this.track) return;

    if (this.index <= 0) return;

    this.index--;

    this.update();
  }

  update() {
    if (!this.track) return;

    this.track.style.transition = "transform .35s ease";
    this.track.style.transform = `translate3d(-${this.index * 100}%,0,0)`;
  }

  async addProduct(button) {
    button.disabled = true;

    const variantId = button.dataset.variant;

    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    });

    const cart = await fetch("/cart.js").then((r) => r.json());

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "recommendations",
      variantId,
      cartData: cart,
    });

    button.disabled = false;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new CartRecommendations();
});

